import { createFileRoute } from '@tanstack/react-router';
import App from '@/App';

export const Route = createFileRoute('/_authenticated')({
	component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
	return <App />;
}
